import {Component, OnInit} from '@angular/core';
import {Actions, EffectsDirective, provideDirectiveEffects} from '@ngneat/effects-ng';
import {PermissionsService} from '@q9elements/ui-kit/common';

import {
  createView,
  deleteView,
  editFilters,
  editView,
  loadViews,
  selectView
} from './models/grid-views.actions';
import {GridView} from './models/interfaces';
import {GridViewEffects} from './services/grid-views.effects';
import {GridViewsService} from './services/grid-views.service';

@Component({
  selector: 'q9ma-grid-views',
  templateUrl: './grid-views.component.html',
  styleUrls: ['./grid-views.component.scss'],
  providers: [provideDirectiveEffects(GridViewEffects)],
  hostDirectives: [EffectsDirective]
})
export class GridViewsComponent implements OnInit {
  views = this.gridViewsService.views;
  selectedView = this.gridViewsService.selectedView;
  isRequirementsManager = this.permissionsService.isRequirementsManager;

  constructor(
    private actions: Actions,
    private gridViewsService: GridViewsService,
    private permissionsService: PermissionsService
  ) {}

  ngOnInit() {
    this.actions.dispatch(loadViews());
  }

  getIconName(opened: boolean) {
    return opened ? 'arrow_up' : 'arrow_down';
  }

  selectView(id: string) {
    this.actions.dispatch(selectView({id}));
  }

  create(view?: GridView) {
    this.actions.dispatch(createView({view}));
  }

  edit(view: GridView) {
    this.actions.dispatch(editView({view}));
  }

  delete(view: GridView) {
    this.actions.dispatch(deleteView({view}));
  }

  editFilters(view: GridView) {
    this.actions.dispatch(editFilters({view}));
  }
}
